import { ArrowUpRight } from "lucide-react";
import { FadeUp, Label } from "./Primitives";
import { TOPICS } from "../data/content";

export default function Topics() {
  return (
    <section
      id="topics"
      data-testid="topics"
      className="relative border-t border-white/8 bg-[#080808]"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-10 py-24 md:py-36">
        <FadeUp className="mb-16 max-w-2xl">
          <Label>The Territory</Label>
          <h2 className="mt-4 font-display text-5xl md:text-7xl leading-[0.9] tracking-tight">
            Four Ways to <br />
            <span className="text-crimson italic">Read</span> the Mind
          </h2>
        </FadeUp>

        <div className="border-t border-white/8">
          {TOPICS.map((t, i) => (
            <FadeUp key={t.n} delay={i * 0.06}>
              <div
                data-testid={`topic-${t.n}`}
                className="group grid grid-cols-12 items-center gap-4 border-b border-white/8 py-8 md:py-10 cursor-pointer transition-colors hover:bg-white/[0.02]"
              >
                <span className="col-span-2 md:col-span-1 font-mono-accent text-sm text-white/30 group-hover:text-crimson transition-colors">
                  {t.n}
                </span>
                <h3 className="col-span-8 md:col-span-3 font-display text-3xl md:text-5xl tracking-tight transition-transform duration-500 group-hover:translate-x-2">
                  {t.title}
                </h3>
                <p className="col-span-12 md:col-span-7 mt-3 md:mt-0 text-white/50 text-sm md:text-base leading-relaxed md:pl-8">
                  {t.desc}
                </p>
                <span className="hidden md:flex col-span-1 justify-end">
                  <ArrowUpRight
                    size={26}
                    className="text-white/30 transition-all duration-500 group-hover:text-crimson group-hover:rotate-45"
                  />
                </span>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
